import React, { useState } from 'react';
import classNames from 'classnames';
import { useField } from 'formik';
import Label from '../lib/Label';
import Error from '../lib/Error';
import Container from '../lib/Container';

export default function FileInput(props) {

    const {
        label,
        name,
        autoComplete,
        placeholder,
        disabled,
        onChange,
        onBlur,
        readOnly,
        fieldId,
        columns,
        required
    } = props;

    const [focused, setFocused] = useState(false);

    const [field, meta] = useField({
        name,
        readOnly,
        id: fieldId || name,
        autoComplete
    });

    function onChangeHandler(event) {
        const value = event;

        if (onChange && typeof onChange === 'function') {
            onChange(value, name)
        }

        return field.onChange(event);
    }

    function onBlurHandler(event) {
        setFocused(false);

        const value = event.target.value;

        if (onBlur && typeof onBlur === 'function') {
            onBlur(value, name)
        }

        return field.onBlur(event);
    }

    function onFocusHandler() {
        setFocused(true);   
    }

    const InputClasses = classNames({
        "block": true,
        "w-full": true,
        "rounded-xl": true,
        "border border-line": !meta?.error,
        "shadow-sm": true,
        "focus:z-10": true,
        "focus:border-primary": true,
        "disabled:bg-light": true,
        "disabled:cursor-not-allowed": true,
        "disabled:opacity-30": true,
        "has-error": meta?.error
    })

    return (
        <Container columns={columns || 1}>
            {label &&
                <Label
                    label={label}
                    name={name}
                    fieldId={fieldId}
                    focused={focused || field.value}
                    required={required}
                    relative
                />
            }

            <input 
                {...field}
                type="file"
                disabled={disabled}
                className={InputClasses}
                placeholder={placeholder}
                onChange={onChangeHandler}
                onFocus={onFocusHandler}
                onBlur={onBlurHandler}
            />

            {meta?.error && (
                <Error error={meta.error}/>
            )}
        </Container>
    )
}
